import { jsx as i } from "react/jsx-runtime";
import { mergeClasses as o } from "../../utils/merge-classes.js";
const a = ({
  as: r = "div",
  children: e,
  className: s,
  ...m
}) => /* @__PURE__ */ i(
  r,
  {
    className: o(
      "grid grid-cols-[minmax(0,80rem)] justify-center pe-[5vw] ps-[5vw] md:pe-[6.25vw] md:ps-[6.25vw]",
      s
    ),
    ...m,
    children: e
  }
);
export {
  a as Container
};
